import { dashboardPreAlertApis, preAlertApis as nextPreAlertApis } from '@apis/next/preAlertApis';
import { preAlertApis } from '@apis/preAlertApis';
import { useMutation } from '@hooks/useMutation';
import type { PutPreAlert } from '@models/PreAlert';
import { useQueryClient } from '@tanstack/react-query';

export const usePutPreAlertCreate = (bookingInquiry: number, d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PutPreAlert) => {
      const response = await preAlertApis.put('/dashboard/pre-alert/{id}/create/', {
        path: { id: bookingInquiry },
        body,
      });
      if (response[400]) {
        throw new Error(`usePutPreAlertCreate: cautched 400 with ${JSON.stringify(response[400])}`);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          nextPreAlertApis.getKeyByPath('get', '/pre-alert/:d2d_no', { params: { d2d_no } }),
        );
        queryClient.invalidateQueries(nextPreAlertApis.getKeyByPath('get', '/pre-alert'));
        queryClient.invalidateQueries(
          dashboardPreAlertApis.getKeyByPath('get', '/dashboard/pre-alert'),
        );
        queryClient.invalidateQueries(
          dashboardPreAlertApis.getKeyByPath('get', '/dashboard/pre-alert/:d2d_no', {
            params: { d2d_no },
          }),
        );
      },
    },
  );
};
